import omniGeoMapService from './reducers';

import * as omniGeoMapServiceOperations from './operations';
import * as omniGeoMapServiceTypes from './types';

export { omniGeoMapServiceOperations, omniGeoMapServiceTypes };

export default omniGeoMapService;
